export const pointContinuousTable = [
  { label: "Puntual", id: "Puntual" },
  { label: "Continuo", id: "Continuo" },
];
